<template>
  <div>
    <a-row style="margin: 0 -12px">
      <a-col style="padding: 0 12px" :xl="6" :lg="24" :md="24" :sm="24" :xs="24">
        <a-card title="事项管理" :bordered="false" :loading="loadingData">
          <a slot="extra" @click="currentItem = {itemName:undefined,itemOrgnization:undefined, itemIcon:undefined, gradeType:undefined,gradeTypes:[] }">
            <a-icon type="plus" />新建
          </a>
          <ul class="c-list">
            <li v-for="item in list" :class="{ active: item.id == currentItem.id }" :key="item.id" @click="edit(item)">
              {{ item.itemName }}
              <a-popover trigger="click" overlayClassName="popover">
                <div slot="content" class="actions">
                  <a-popconfirm title="确认删除吗?" ok-text="是" cancel-text="否" @confirm="del(item.id)">
                    <p>删除</p>
                  </a-popconfirm>
                </div>
                <a-icon type="more" @click.stop="() => { }" />
              </a-popover>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col style="padding: 0 12px" :xl="18" :lg="24" :md="24" :sm="24" :xs="24">
        <a-card :bordered="false" :title="currentItem.itemName ? currentItem.itemName : '事项'" :loading="loadingData">
          <a-form-model ref="ruleForm" :model="currentItem" :rules="rules" :label-col="labelCol"
            :wrapper-col="wrapperCol">
            <a-form-model-item  label="事项名称" prop="itemName">
              <a-input v-model="currentItem.itemName" placeholder="请输入事项名称" />
            </a-form-model-item>
            <a-form-model-item label="所属部门" prop="itemOrgnization">
              <a-select v-model="currentItem.itemOrgnization" placeholder="请选择所属部门">
                <a-select-option v-for="item in orgs" :value="item.id" :key="item.id">{{ item.orgName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="毕业类型" prop="gradeTypes">
              <a-checkbox-group v-model="currentItem.gradeTypes" placeholder="请选择毕业类型">
               <a-checkbox v-for="item in gradeTypeList" :value="item.code" :key="item.code">{{ item.name }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="显示顺序">
              <a-input v-model="currentItem.sort" type="number" placeholder="请输入显示顺序" />
            </a-form-model-item>
            <a-form-model-item label="客户端图标" prop="itemIcon">
              <c-upload name="file" list-type="picture-card" class="avatar-uploader" 
                :action="uploadFileUri" @change="handleChange">
                <img v-if="currentItem.itemIcon" :src="currentItem.itemIcon" alt="avatar" />
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </c-upload>
            </a-form-model-item>
            <a-form-model-item label="办理日期" prop="endTime">
              <a-date-picker v-model="currentItem.startTime"  format="YYYY-MM-DD HH:mm:ss" :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"/>
              -
              <a-date-picker v-model="currentItem.endTime"   format="YYYY-MM-DD HH:mm:ss" :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"/>
            </a-form-model-item>
            <a-form-model-item label="是否启用">
              <a-switch default-checked v-model="currentItem.status" />
            </a-form-model-item>
            <a-form-model-item label="是否允许手动办理">
              <a-switch default-checked v-model="currentItem.isHandle" />
            </a-form-model-item>
            <a-form-model-item label="系统对接">
              <a-switch default-checked v-model="currentItem.isdock" />
            </a-form-model-item>
            <a-form-model-item label="接口链接" v-if="currentItem.isdock">
              <a-input v-model="currentItem.dockurl" />
            </a-form-model-item>
            <!-- <a-form-model-item label="流程配置">
              <a-switch default-checked v-model="currentItem.isprocess" />
            </a-form-model-item>
            <a-form-model-item label="选择流程" v-if="currentItem.isprocess">
              <a-select default-value="1" disabled="true">
                <a-select-option value="1">Option 1</a-select-option>
                <a-select-option value="2">Option 2</a-select-option>
                <a-select-option value="3">Option 3</a-select-option>
              </a-select>
            </a-form-model-item> -->
            <a-form-model-item label="咨询电话">
              <a-input v-model="currentItem.consultationTelephone" placeholder="请输入咨询电话 多个手机号请采用 如下形式填写 xxx:12345678910,bbb:12345678911" />
            </a-form-model-item>
            <a-form-model-item label="办理说明">
              <a-input v-model="currentItem.handleDesc" placeholder="请输入办理说明" />
            </a-form-model-item>
            <a-form-model-item label="办理链接">
              <a-input v-model="currentItem.handleUrl" placeholder="请输入办理链接" />
            </a-form-model-item>
            <a-form-model-item label="已办理文案">
              <a-textarea style="margin-top: 15px" v-model="currentItem.dockSuccess" placeholder="请输入已办理文案内容"
                :auto-size="{ minRows: 3, maxRows: 8 }" />
            </a-form-model-item>
            <a-form-model-item label="未办理文案">
              <a-textarea style="margin-top: 15px" v-model="currentItem.dockFailed" placeholder="请输入未办理文案内容"
                :auto-size="{ minRows: 3, maxRows: 8 }" />
            </a-form-model-item>
          </a-form-model>
          <div class="footer-submit-btns">
            <a-button type="primary" @click="submit">保存</a-button>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getAllEventsByOrg, update, save, del,serveUpdate} from "@/services/event";
import { queryAllOrganizations } from "@/services/organization";
import uploadFileUri from "@/services/uploadFileUri";
import buildUrl from "@/services/buildUrl";
import { getTreeByCode } from "@/services/dict";
import moment from 'moment';
// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsDataURL(img);
// }
const rules = {
  itemName: [{ required: true, message: '请输入事项名称', trigger: 'change' }],
  itemOrgnization: [{ required: true, message: '请选择事项所属机构', trigger: 'change'}],
  gradeTypes: [{ required: true, message: '请选择毕业类型', trigger: 'change' }],
  itemIcon: [{ required: true, message: '请上传客户端图标', trigger: 'change' }],
  // endTime: [{ required: true, message: '请选择办理日期', trigger: 'change' }],
}
export default {
  name: "EventManagement",
  data() {
    return {
      moment,
      rules,
      visible: false,
      loading: false,
      loadingData: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      orgs: [],
      gradeTypeList: [],
      list: [],
      currentItem: {gradeTypes:[]},
      educationList: [],
      uploadFileUri,
      buildUrl,
    };
  },
  methods: {
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        this.loading = false;
        this.currentItem.itemIcon = info.file.response.data.filePath;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    edit(item) {
      console.log(item);
      this.currentItem = Object.assign(
        { gradeTypes: item.gradeType ? item.gradeType.split(",") : [] },
        item,
        {isdock: item.isdock==0, status: item.status==0, isprocess: item.isprocess==0, isHandle: item.isHandle==0},
      );
    },
    submit() {
      this.$refs.ruleForm.validate(async(valid) => {
        if (valid) {
          if((this.currentItem.startTime&&this.currentItem.endTime)&&moment(this.currentItem.startTime).isAfter(moment(this.currentItem.endTime))){
            this.$message.error('开始时间不能大于结束时间');
            return;
          }
          let item = this.formatData(this.currentItem);
          if (item.id) {
            await update(item);
          } else {
            let datas = await save(item);
            await serveUpdate({itemId: datas.id})
          }
          this.$message.success("操作成功");
          this.loadData();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },
    formatData(currentItem) {
      let item = Object.assign({}, currentItem);
      item.gradeType = item.gradeTypes ? item.gradeTypes.join(",") : undefined;
      item.isdock = item.isdock ? "0" : "1";
      item.status = item.status ? "0" : "1";
      item.isprocess = item.isprocess ? "0" : "1";
      item.isHandle = item.isHandle? "0" : "1";
      item.startTime = item.startTime?moment(item.startTime).format('YYYY-MM-DD HH:mm:ss'):null;
      item.endTime = item.endTime?moment(item.endTime).format('YYYY-MM-DD HH:mm:ss'):null
      return item;
    },
    del(id) {
      del(id).then(() => {
        this.$message.success("操作成功");
        this.loadData();
      });
    },
    async loadData() {
      this.list = (await getAllEventsByOrg()).map((o) => {
        o.visible = false;
        return o;
      });
    },
  },
  async mounted() {
    this.loadingData = true;
    await this.loadData();
    if(this.list.length){
      this.edit(this.list[0]);
    }
    this.orgs = await queryAllOrganizations({
      type: "部门",
      status: 0,
      name: "",
    });
    this.loadingData = false;
    this.educationList = await getTreeByCode("XL");
    this.gradeTypeList = await getTreeByCode("BYLX");
  },
  watch:{
    'currentItem.gradeTypes'(){
      this.currentItem.gradeType=this.currentItem.gradeTypes.length>0?this.currentItem.gradeTypes.join(","):undefined;
    }
  }
};
</script>

<style lang="less" scoped>
.c-list {
  list-style: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;

  li {
    padding: 15px 0;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:first-child {
      padding-top: 0;
    }
  }

  .active {
    color: @primary-color;
  }
}
</style>
